export const exerciseModelMixin = {
  data() {
    return {
      exerciseModelObj: {
        alternativeExercise: null,
        description: null,
        exerciseDifficulty: null,
        label: '',
        mediaAssets: {
          coverPhoto: {
            url: null,
          },
          coverVideo: {
            url: null,
            thumbnail: null,
          },
          thumbnailPhoto: {
            url: null,
          },
        },
        muscleGroup: null,
        muscleGroups: [],
        org_id: null,
        requiredEquipment: {
          unweighted: [],
          weighted: null,
        },
        steps: [],
        tips: [],
        trainer_id: '0',
        user_id: '0',
      },
    };
  },
  methods: {
    getExerciseModel() {
      return this.exerciseModelObj;
    },
  },
};
